import Input from '../../components/Input/index';
import Button from '../../components/Button/index'

import { Container, DivContactUs, DivForms } from './styled';
import { MdEmail, MdForum } from 'react-icons/md'
import TextArea from '../../components/TextArea';
import {alert} from '../../components/Alert';

import axios from 'axios';
import { useState } from 'react'
import WpIcon from '../../assets/whatsapp-icon.png'

const Contacts = () => {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");
    const [mensagem, setMensagem] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post('https://struct-hotel-api.herokuapp.com/contact', {
                email,
	            name, 
                message: mensagem,
                phone: telefone
            })
            console.log(response.data)
            if(response.data) {
                window.alert("Mensagem enviada!", 'success')
            }
            
        } catch (error) {
            window.alert('Erro, tente novamente.','error');
        }
    };

    return (
        <Container>
            <DivContactUs>
                <div className="texts-div">
                    <h1>Entre em contato conosco</h1>
                    <div className="container-p">
                        <p>Faça sua reserva nos enviando um email ou ligando pelo telefone</p>
                    </div>
                </div>
                <div className="options-div">
                    <div className="container-options-div">
                        <MdForum />
                        <span>Dúvidas frequentes</span>
                    </div>
                    <div className="container-options-div">
                        <MdEmail />
                        <span>exemplo@gmail.com</span>
                    </div>
                    <div id="whatsapp-div" className="container-options-div">
                        <img src={WpIcon}/>
                        <a href="https://wa.me/<numero>" target="_blank">Entrar em contato por WhatsApp</a>
                        {/* adicionar o número em <numero>, sendo o código do pais, ddd e o número de fato, tudo junto
                        sem espaços.*/}
                    </div>
                </div>
            </DivContactUs>
            <DivForms>
                <form onSubmit={handleSubmit}>
                    <Input 
                        placeholder="Nome"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <Input 
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <Input
                        placeholder="Telefone"
                        value={telefone}
                        onChange={(e) => setTelefone(e.target.value)}
                    />
                    <div className="div-text-area">
                        <span>Mensagem</span>
                        <TextArea
                            className="text-area-contact"
                            placeholder="Digite aqui sua mensagem..."
                            value={mensagem}
                            onChange={(e) => setMensagem(e.target.value)}
                        />
                    </div>
                    <Button 
                        className="button-contact" 
                        type="submit"
                        format="submit"
                    >Confirmar</Button>
                </form>
            </DivForms>
        </Container>
        
    );
}

export default Contacts;